"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyAll = exports.updatePrice = exports.unselect = exports.select = exports.fetchFeaturesFailed = exports.fetchFeaturesSuccess = exports.fetchFeaturesRequest = exports.uploadContractFileFailure = exports.uploadContractFileSuccess = exports.uploadContractFileStatus = exports.uploadContractFileRequest = exports.setCustomerLogoFailure = exports.setCustomerLogoSuccess = exports.setCustomerLogoRequest = exports.saveCustomerFailure = exports.saveCustomerSuccess = exports.saveCustomerRequest = exports.fetchContractFilesFailure = exports.fetchContractFilesSuccess = exports.fetchContractFilesRequest = exports.fetchCustomerFailure = exports.fetchCustomerSuccess = exports.fetchCustomerRequest = exports.clearState = exports.validateStepSuccess = exports.validateStepFailure = exports.changeStep = exports.setYtjCompanyFailure = exports.setYtjCompanySuccess = exports.setYtjCompanyRequest = exports.toggleClient = exports.removeFile = exports.setFiles = exports.setCompanyLogo = exports.updateField = void 0;
const ActionTypes = require("../../actionTypes/customer/wizard");
const updateField = (key, value) => ({
    type: ActionTypes.UPDATE_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateField = updateField;
const setCompanyLogo = (file, dataUrl) => ({
    type: ActionTypes.SET_COMPANY_LOGO,
    payload: {
        file,
        dataUrl
    }
});
exports.setCompanyLogo = setCompanyLogo;
const setFiles = (files) => ({
    type: ActionTypes.SET_FILES,
    payload: files
});
exports.setFiles = setFiles;
const removeFile = (files) => ({
    type: ActionTypes.REMOVE_FILE,
    payload: files
});
exports.removeFile = removeFile;
const toggleClient = () => ({
    type: ActionTypes.TOGGLE_CLIENT
});
exports.toggleClient = toggleClient;
const setYtjCompanyRequest = (company) => ({
    type: ActionTypes.SET_YTJ_COMPANY_REQUEST,
    payload: company
});
exports.setYtjCompanyRequest = setYtjCompanyRequest;
const setYtjCompanySuccess = (company) => ({
    type: ActionTypes.SET_YTJ_COMPANY_SUCCESS,
    payload: company
});
exports.setYtjCompanySuccess = setYtjCompanySuccess;
const setYtjCompanyFailure = (error) => ({
    type: ActionTypes.SET_YTJ_COMPANY_FAILURE,
    payload: error
});
exports.setYtjCompanyFailure = setYtjCompanyFailure;
const changeStep = (wizardStep) => ({
    type: ActionTypes.CHANGE_STEP,
    payload: {
        wizardStep
    }
});
exports.changeStep = changeStep;
const validateStepFailure = (errors) => ({
    type: ActionTypes.VALIDATE_STEP_FAILURE,
    payload: {
        errors
    }
});
exports.validateStepFailure = validateStepFailure;
const validateStepSuccess = (wizardStep) => ({
    type: ActionTypes.VALIDATE_STEP_SUCCESS,
    payload: {
        wizardStep
    }
});
exports.validateStepSuccess = validateStepSuccess;
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
const fetchCustomerRequest = (customerId) => ({
    type: ActionTypes.FETCH_CUSTOMER_REQUEST,
    payload: customerId
});
exports.fetchCustomerRequest = fetchCustomerRequest;
const fetchCustomerSuccess = (customer) => ({
    type: ActionTypes.FETCH_CUSTOMER_SUCCESS,
    payload: customer
});
exports.fetchCustomerSuccess = fetchCustomerSuccess;
const fetchCustomerFailure = (error) => ({
    type: ActionTypes.FETCH_CUSTOMER_FAILURE,
    payload: error
});
exports.fetchCustomerFailure = fetchCustomerFailure;
const fetchContractFilesRequest = (customerId) => ({
    type: ActionTypes.FETCH_CONTRACT_FILES_REQUEST,
    payload: customerId
});
exports.fetchContractFilesRequest = fetchContractFilesRequest;
const fetchContractFilesSuccess = (contractFiles) => ({
    type: ActionTypes.FETCH_CONTRACT_FILES_SUCCESS,
    payload: contractFiles
});
exports.fetchContractFilesSuccess = fetchContractFilesSuccess;
const fetchContractFilesFailure = (error) => ({
    type: ActionTypes.FETCH_CONTRACT_FILES_FAILURE,
    payload: error
});
exports.fetchContractFilesFailure = fetchContractFilesFailure;
const saveCustomerRequest = (uuid, basicInformation, customerLogo, contractFiles) => ({
    type: ActionTypes.SAVE_CUSTOMER_REQUEST,
    payload: {
        uuid,
        basicInformation,
        customerLogo,
        contractFiles
    }
});
exports.saveCustomerRequest = saveCustomerRequest;
const saveCustomerSuccess = (customer) => ({
    type: ActionTypes.SAVE_CUSTOMER_SUCCESS,
    payload: customer
});
exports.saveCustomerSuccess = saveCustomerSuccess;
const saveCustomerFailure = (error) => ({
    type: ActionTypes.SAVE_CUSTOMER_FAILURE,
    payload: error
});
exports.saveCustomerFailure = saveCustomerFailure;
const setCustomerLogoRequest = (uuid, file) => ({
    type: ActionTypes.SET_CUSTOMER_LOGO_REQUEST,
    payload: {
        uuid,
        file
    }
});
exports.setCustomerLogoRequest = setCustomerLogoRequest;
const setCustomerLogoSuccess = () => ({
    type: ActionTypes.SET_CUSTOMER_LOGO_SUCCESS
});
exports.setCustomerLogoSuccess = setCustomerLogoSuccess;
const setCustomerLogoFailure = (error) => ({
    type: ActionTypes.SET_CUSTOMER_LOGO_FAILURE,
    payload: error
});
exports.setCustomerLogoFailure = setCustomerLogoFailure;
const uploadContractFileRequest = (uuid, files) => ({
    type: ActionTypes.UPLOAD_CONTRACT_FILE_REQUEST,
    payload: {
        uuid,
        files
    }
});
exports.uploadContractFileRequest = uploadContractFileRequest;
const uploadContractFileStatus = (uuid, uploaded) => ({
    type: ActionTypes.UPLOAD_CONTRACT_FILE_STATUS,
    payload: {
        uuid,
        uploaded
    }
});
exports.uploadContractFileStatus = uploadContractFileStatus;
const uploadContractFileSuccess = (uuid) => ({
    type: ActionTypes.UPLOAD_CONTRACT_FILE_SUCCESS,
    payload: uuid
});
exports.uploadContractFileSuccess = uploadContractFileSuccess;
const uploadContractFileFailure = (uuid, error) => ({
    type: ActionTypes.UPLOAD_CONTRACT_FILE_FAILURE,
    payload: {
        uuid,
        error
    }
});
exports.uploadContractFileFailure = uploadContractFileFailure;
const fetchFeaturesRequest = (customerId) => ({
    type: ActionTypes.FETCH_FEATURES_REQUEST,
    payload: customerId
});
exports.fetchFeaturesRequest = fetchFeaturesRequest;
const fetchFeaturesSuccess = (features) => ({
    type: ActionTypes.FETCH_FEATURES_SUCCESS,
    payload: {
        features
    }
});
exports.fetchFeaturesSuccess = fetchFeaturesSuccess;
const fetchFeaturesFailed = (error) => ({
    type: ActionTypes.FETCH_FEATURES_FAILED,
    payload: {
        error
    }
});
exports.fetchFeaturesFailed = fetchFeaturesFailed;
const select = (feature) => ({
    type: ActionTypes.SELECT,
    payload: {
        feature
    }
});
exports.select = select;
const unselect = (feature) => ({
    type: ActionTypes.UNSELECT,
    payload: {
        feature
    }
});
exports.unselect = unselect;
const updatePrice = (uuid, price) => ({
    type: ActionTypes.UPDATE_PRICE,
    payload: {
        uuid,
        price
    }
});
exports.updatePrice = updatePrice;
const copyAll = (features) => ({
    type: ActionTypes.COPY_ALL,
    payload: {
        features
    }
});
exports.copyAll = copyAll;
//# sourceMappingURL=wizard.js.map